const state = {
  loadingCount: 0
};

const getters = {
  isLoading () {
    return state.loadingCount > 0;
  }
};

const actions = {
  startLoading ({ commit }) {
    commit('INCREMENT_LOADING');
  },
  stopLoading ({ commit }) {
    commit('DECREMENT_LOADING');
  },
  resetLoading ({ commit }) {
    commit('RESET_LOADING');
  }
};

const mutations = {
  INCREMENT_LOADING (state) {
    state.loadingCount++;
  },
  DECREMENT_LOADING (state) {
    if (state.loadingCount > 0) {
      state.loadingCount--;
    }
  },
  RESET_LOADING (state) {
    state.loadingCount = 0;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
